export default __webpack_public_path__ + "static/media/experts.ba686dd3.svg";